// extracted by mini-css-extract-plugin
export default {"brand":"srKw1ZQg6lqobM6KEWiC","navbar":"lnF2gacVllOiVsUOeXAZ","nav-sidebar":"TqsyJ9sA3Y2h3bgXduVU","toggler":"g7O8ae1aLe5fx0zHfxWL"};